import { useState } from "react";
import AppShell from "./components/AppShell";
import TargetPage from "./pages/TargetPage";
import ArsenalPage from "./pages/ArsenalPage";
import BattlePage from "./pages/BattlePage";
import ProfilePage from "./pages/ProfilePage";

function App() {
  const [activeTab, setActiveTab] = useState("target");

  const renderPage = () => {
    switch (activeTab) {
      case "target":
        return <TargetPage />;
      case "arsenal":
        return <ArsenalPage />;
      case "battle":
        return <BattlePage />;
      case "profile":
        return <ProfilePage />;
      default:
        return <TargetPage />;
    }
  };

  return (
    <AppShell activeTab={activeTab} onTabChange={setActiveTab} dark={activeTab === "battle"}>
      {renderPage()}
    </AppShell>
  );
}

export default App;
